angular.module 'zc.projects.reports'

.directive 'zcDownloadMonthlyReportButton', ($q, $translate, ReportCampaignStats, Meta, $filter, campaignStatusTexts, clientReportCsvCreator) ->
  restrict: 'E'
  scope:
    filters: '='
    project: '='
    campaigns: '='
    status: '='
    isLatest: '='
    isAb: '='
  template: """
            <button
              class="btn btn-sm btn-default"
              ng-csv="getCSV()"
              add-bom="true"
              charset="utf-16"
              field-separator="\\t"
              filename="{{filename}}">
              <i class="fa fa-download"></i> {{ 'projectsReports.directives.downloadMonthlyReportButton.csv_keishiki_de_daunroodo' | translate }}
            </button>
            """
  link: (scope, element, attrs) ->
    scope.prepareCampaigns = (campaigns) ->
      $q (resolve) ->
        promises = for campaign_child in campaigns
          ReportCampaignStats.find
            apikey: scope.project.apikey
            dimension: if scope.isLatest then 'daily' else 'monthly'
          ,
            match:
              status: scope.status
              campaign_id: campaign_child.id
              begin_at: scope.filters.begin_at
              start_at: scope.filters.start_at if scope.filters.start_at
            sort:
              end_at: -1
        $q.all(promises)
        .then (res) ->
          campaigns = []

          for campaignStatArray in res
            for stat in campaignStatArray
              campaign = _.chain(scope.campaigns)
                .filter((c) -> c.id == stat.campaign_id)
                .head()
                .value()

              campaign = _.assignIn {}, campaign
              campaign.stats = stat

              start_at = new Date(scope.filters.begin_at)
              end_at = moment(scope.filters.begin_at).add(1, 'day').endOf('month').toDate()
              if new Date(campaign.start_at) > start_at
                start_at = new Date(campaign.start_at)
              if new Date(campaign.end_at) < end_at
                end_at = new Date(campaign.end_at)

              campaign.start_at = start_at
              campaign.end_at = end_at
              campaigns.push campaign
          resolve campaigns

    scope.getCSV = ->
      scope.filename = "report_#{scope.project.apikey}_#{moment(scope.filters.begin_at).format('YYYYMMDD')}.csv"
      $q (resolve) ->
        scope.prepareCampaigns(scope.campaigns)
        .then (campaignsWithStats) ->
          clientReportCsvCreator.createCsv(scope.project, campaignsWithStats, scope.isAb)
        .then (res) ->
          if scope.isLatest
            res.unshift [
              $translate.instant('projectsReports.directives.downloadMonthlyReportButton.csv_header_preliminary', {
                yearmonth: moment(scope.filters.start_at).format($filter('translate')('sharedModules.dateTimeFormats.yearMonth')),
                yearmonthday: moment(scope.filters.start_at).format($filter('translate')('sharedModules.dateTimeFormats.yearMonthDay'))
              })
            ]
          else
            res.unshift [
              $translate.instant('projectsReports.directives.downloadMonthlyReportButton.csv_header', {
                yearmonth: moment(scope.filters.start_at).format($filter('translate')('sharedModules.dateTimeFormats.yearMonth')),
              })
            ]
          resolve res



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.reports/download_monthly_report_button.directive.coffee